module.exports = "<hybse-admin-adduser [userType]=\"'Investor'\"></hybse-admin-adduser>\n"


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/BEX-VoucherAdmin/src/app/components/pages/users/investor/adduser/investor-add-user.component.html
// module id = ../../../../../src/app/components/pages/users/investor/adduser/investor-add-user.component.html
// module chunks = main